// extracted by mini-css-extract-plugin
export var filterIncDec = "_4r-0";
export var leftBorder = "_4r-1";
export var rightBorder = "_4r-2";
export var stringInput = "_4r-3";